var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoCar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 384.96 287.97",
    style: {
      enableBackground: "new 0 0 384.96 287.97"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#010202;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M308.87,146.28C303.98-1.16,192.48,9.18,192.48,9.18S80.98-1.16,76.09,146.28 c-15.09,6.4-25.74,21.38-25.74,38.73c0,23.12,18.92,42.04,42.04,42.04h200.18c23.12,0,42.04-18.92,42.04-42.04 C334.61,167.66,323.96,152.68,308.87,146.28z M193.61,46.21c0,0,83.85-6.34,83.85,86.29c-55.18,0-83.85,0-83.85,0s-28.67,0-83.85,0 C109.76,39.87,193.61,46.21,193.61,46.21z M105,208.57c-12.46,0-22.56-10.1-22.56-22.56c0-12.46,10.1-22.56,22.56-22.56 c12.46,0,22.56,10.1,22.56,22.56C127.56,198.47,117.46,208.57,105,208.57z M277.21,208.57c-12.46,0-22.56-10.1-22.56-22.56 c0-12.46,10.1-22.56,22.56-22.56c12.46,0,22.56,10.1,22.56,22.56C299.77,198.47,289.67,208.57,277.21,208.57z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M79.7,259.46c0,11.13,11.38,20.24,25.3,20.24c13.91,0,25.29-9.11,25.29-20.24v-23.35H79.7V259.46z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M251.44,259.46c0,11.13,11.38,20.24,25.29,20.24c13.91,0,25.29-9.11,25.29-20.24v-23.35h-50.59V259.46z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoCar);
export default __webpack_public_path__ + "static/media/ico_car.a49b8339.svg";
export { ForwardRef as ReactComponent };